/**
 * Globally wrap plain ™ in .trademark-symbol spans for Android-safe superscript.
 * Skips nodes already inside .trademark-symbol. Re-runs on Shopify section load.
 */
(function () {
  const TM = "\u2122";
  const ROOT_SELECTORS = [
    ".rte",
    ".headline--rich",
    ".headline",
    ".headline__title",
    ".hero__title",
    ".fas-card__title",
    ".fas-card__title-link",
    ".main-article__title",
    ".main-article__body",
    ".main-blog__heading",
    ".srt-rte",
    ".strength-precision-slider__heading",
    ".sps-card__heading",
    ".wt-comparison-table__heading",
    ".wt-comparison-table__column-heading",
    ".cas-slide__overlay-heading",
    ".cas-slide__card-heading",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
  ].join(",");

  function shouldProcessTextNode(node) {
    if (!node?.textContent?.includes(TM)) return false;
    const parent = node.parentElement;
    if (!parent) return false;
    if (parent.classList?.contains("trademark-symbol")) return false;
    if (parent.closest(".trademark-symbol")) return false;
    if (["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"].includes(parent.tagName)) {
      return false;
    }
    return true;
  }

  function wrapTrademarkInElement(root) {
    if (!root?.querySelectorAll) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return shouldProcessTextNode(node)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    const textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((textNode) => {
      const parts = textNode.textContent.split(TM);
      if (parts.length < 2) return;

      const fragment = document.createDocumentFragment();
      parts.forEach((part, index) => {
        if (part) fragment.appendChild(document.createTextNode(part));
        if (index < parts.length - 1) {
          const span = document.createElement("span");
          span.className = "trademark-symbol";
          span.textContent = TM;
          fragment.appendChild(span);
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function run() {
    document.querySelectorAll(ROOT_SELECTORS).forEach((element) => {
      wrapTrademarkInElement(element);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);
})();
